import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type PaymentsSourceType} from 'web-app/util/graphql/api-types';

import {type FlexiblePayments} from './types';

const domain = 'MODALS/PAY_NOW';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (
        amount: number,
        paymentPayload: string,
        institutionId: string,
        billPayerId: string,
        enabledPaymentsSourceTypes: PaymentsSourceType[],
        flexiblePayments: FlexiblePayments | null,
        shouldMakeFeeCalculation: boolean,
    ) => ({
        amount,
        paymentPayload,
        institutionId,
        billPayerId,
        enabledPaymentsSourceTypes,
        flexiblePayments,
        shouldMakeFeeCalculation,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: startSubmit} = createAction(`${domain}/START_SUBMIT`, () => ({}));

export const {action: stopSubmit} = createAction(`${domain}/STOP_SUBMIT`, () => ({}));
